import { useState } from "react";
import MenuFrame from "../frames/menu_frame";
import { Alert, Autocomplete, Backdrop, Box, Button, Chip, CircularProgress, Divider, Fab, FormControlLabel, Grid, IconButton, LinearProgress, Paper, Switch, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Zoom } from "@mui/material";
import { adjustPackagingFuelField, adjustPackagingGstField, adjustPackagingTotalField, calcPackagingField, deletePackaging, getClientList, getPackaging, getPackagingCn, packagingBooking, reset_tax, validCn, validPercentage, validPrice } from "./booking_halper";
import DeleteIcon from '@mui/icons-material/Delete';
import { BusinessTwoTone, Inventory2TwoTone } from "@mui/icons-material";
import { dateUsaToTimestamp, getCurrentDate } from "../frames/common";
import DropDownLoading from "../frames/dropdown_loading";
import { useSearchParams } from "react-router-dom";

const cu_date = getCurrentDate();

function Packaging() {
    const [searchParams, setSearchParams] = useSearchParams();
    const [isLoading, setIsLoading] = useState(false);
    const [inputErrors, setInputErrors] = useState({});
    const [cnList, setCnList] = useState(null);
    const [clientList, setClientList] = useState(null);
    const [isCnWise, setIsCnWise] = useState(!Boolean(searchParams.get("client")));
    const [bookingList, setBookingList] = useState(null);
    const [isFuel, setIsFuel] = useState(false);
    const [isGst, setIsGst] = useState(false);
    const [taxLock, setTaxLock] = useState(false);
    const [alertMessage, setAlertMessage] = useState(null);

    const initData = async (auth) => {
        if (!auth) return;
        setCnList(await getPackagingCn());
        setClientList(await getClientList("packaging"));
    }

    const __error_handler = (test, vr, msg) => {
        if (test) {
            inputErrors[vr] = "";
            setInputErrors({ ...inputErrors });
        } else {
            inputErrors[vr] = msg;
            setInputErrors({ ...inputErrors });
        }
        return !test;
    }

    const handleSubmit = (event) => {
        event.preventDefault();
        const data = new FormData(event.currentTarget);
        const date = dateUsaToTimestamp(data.get("date"));
        const cn_no = data.get("cn_no");
        const client = data.get("client");
        const description = data.get("desc");
        const packaging = data.get("packaging");
        const total = data.get("total");
        const fuel = data.get("fuel");
        const gst = data.get("gst");

        var flag = true;
        if (isCnWise && __error_handler(validCn(cn_no), "cn_no", "Incorrect consignment number.")) {
            flag = false;
        }
        if (flag) {
            var _json = {};
            if (isCnWise) {
                _json = {
                    "cn_num": cn_no, "time": date, "description": description, "ac_id": null,
                    "amount": Number(packaging), "fuel": Number(fuel), "gst": Number(gst), "total": Number(total)
                };
            } else {
                let client_id = null;
                clientList.some((itm) => {
                    if (itm.client_id === client) {
                        client_id = itm.ac_id;
                        return true;
                    }
                    return false;
                });
                _json = {
                    "cn_num": null, "time": date, "description": description, "ac_id": client_id,
                    "amount": Number(packaging), "fuel": 0, "gst": 0, "total": 0
                };
            }
            packagingBooking(_json).then((_) => {
                setAlertMessage({ severity: "success", message: "The packaging is bookied succefully." });
                setIsLoading(false);
                event.target.reset();
            }).catch((err) => {
                setAlertMessage({ severity: "error", message: err['message'] });
                setIsLoading(false);
            });
        } else {
            setIsLoading(false);
        }
    }

    const validateInputs = () => {
        setIsLoading(true);
        return true;
    }

    const handleTypeSwitch = () => {
        reset_tax();
        setTaxLock(false);
        setIsCnWise(!isCnWise);
        setSearchParams("", "");
    }

    const handleCnChange = (event) => {
        const cn = event.target.value.toUpperCase();
        if (!cn || !validCn(cn)) return;
        setIsLoading(true);
        getPackaging(cn).then((res) => {
            document.getElementsByName("desc")[0].value = "Consignment batch " + cn;
            setTaxLock(res[2]);
            setBookingList(res[3]);
            if (!res[2]) {
                setIsFuel(false);
                setIsGst(false);
                reset_tax();
            } else {
                setIsFuel(res[0] !== 0);
                setIsGst(res[1] !== 0);
            }
            setIsLoading(false);
        }).catch((err) => {
            setIsLoading(false);
            console.error(err);
        })
    }

    const handleClientChange = (event) => {
        if (clientList === null) return;
        const id = event.target.value;
        document.getElementsByName("desc")[0].value = "Service on request";
        reset_tax();
        setTaxLock(true);
        for (let idx = 0; idx < clientList.length; idx++) {
            const clt = clientList[idx];
            if (clt.client_id === id) {
                if (clt.fuel_charge && clt.fuel_charge !== 0) {
                    setIsFuel(true);
                    document.getElementsByName("fuel_rate")[0].value = clt.fuel_charge;
                } else {
                    setIsFuel(false);
                }
                if (clt.gst_num) {
                    setIsGst(true);
                } else {
                    setIsGst(false);
                }
                break;
            }

        }
    }

    const handlePackagingChange = (event) => {
        const price = event.target.value;
        __error_handler(validPrice(price), "packaging", "Please fill a valid amount.");
        if (validPrice(price)) calcPackagingField();
    }

    const handleFuelChange = (event) => {
        if (taxLock) calcPackagingField();
        const price = event.target.value;
        __error_handler(validPrice(price), "fuel", "Please fill a fuel charge.");
        if (validPrice(price)) adjustPackagingFuelField();
    }

    const handleGSTChange = (event) => {
        if (taxLock) calcPackagingField();
        const price = event.target.value;
        __error_handler(validPrice(price), "gst", "Please fill a valid price.");
        if (validPrice(price)) adjustPackagingGstField();
    }

    const handleFuelrateChange = (event) => {
        const per = event.target.value;
        __error_handler(validPercentage(per), "fuel_rate", "Please enter fuel rate maximum 35%.");
        if (validPercentage(per)) calcPackagingField();
    }

    const handleGstRateChange = (event) => {
        const per = event.target.value;
        __error_handler(validPercentage(per), "gst_rate", "Please enter GST rate maximum 28%.");
        if (validPercentage(per)) calcPackagingField();
    }

    const handleIsGstChange = (event) => {
        setIsGst(event.target.checked);
        calcPackagingField();
    }

    const handleIsFuelChange = (event) => {
        setIsFuel(event.target.checked);
        calcPackagingField();
    }

    const handleTotalChange = (event) => {
        const amt = event.target.value;
        __error_handler(validPrice(amt), "total", "Please fill a valid amount.");
        adjustPackagingTotalField();
    }

    const handleDeletePackaging = (packaging) => {
        if (packaging.ispaid === 0) {
            setIsLoading(true);
            deletePackaging({ "pack_id": packaging.pack_id }).then((res) => {
                console.log(res);
                setIsLoading(false);
                setBookingList(bookingList.filter(element => element.pack_id !== packaging.pack_id));
            }).catch((err) => {
                console.error(err);
                setIsLoading(false);
            });
        } else {
            setAlertMessage({ severity: "error", message: "This packaging is already paid." });
        }
    }

    return (
        <MenuFrame permission="BOOKING_PACKAGING" onInit={initData} screen="PACKAGING">
            {cnList === null || clientList === null ? <LinearProgress color="primary" /> : ""}
            <Backdrop sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })} open={isLoading} >
                <CircularProgress color="inherit" />
            </Backdrop>

            <Grid size={{ xs: 12, sm: 10 }} component="form" onSubmit={handleSubmit} noValidate>
                <Grid container spacing={2} component={Paper} sx={{ p: 2 }}>
                    {alertMessage === null ? "" :
                        <Grid size={12}>
                            <Alert severity={alertMessage.severity}>{alertMessage.message}</Alert>
                        </Grid>
                    }
                    <Grid size={{ xs: 12, sm: 4 }}>
                        <TextField variant="outlined" name="date" type="date" fullWidth error={inputErrors.date} defaultValue={cu_date} slotProps={{ htmlInput: { max: cu_date, min: "2024-04-01" } }} helperText={inputErrors.date} placeholder="Date" />
                    </Grid>
                    <Grid size={{ xs: 12, sm: 4 }}>
                        {isCnWise ?
                            <Zoom in={isCnWise} unmountOnExit>
                                <Autocomplete
                                    disablePortal
                                    defaultValue={searchParams.get("cn") ?? ""}
                                    noOptionsText={<DropDownLoading title="Loading Consignment ..." />}
                                    options={cnList === null ? [] : cnList}
                                    onBlur={handleCnChange}
                                    renderInput={(params) => <TextField {...params} variant="outlined" name="cn_no" fullWidth error={inputErrors.cn_no} type="text" helperText={inputErrors.cn_no} autoFocus placeholder="Consignment Number" label="CN Number" />}
                                />
                            </Zoom>
                            : ""
                        }
                        {!isCnWise ?
                            <Zoom in={!isCnWise} unmountOnExit>
                                <Autocomplete
                                    disablePortal
                                    defaultValue={{ "client_id": searchParams.get("client") ?? "", "name": "" }}
                                    noOptionsText={<DropDownLoading title="Loading Clients ..." />}
                                    onBlur={handleClientChange}
                                    options={clientList === null ? [] : clientList}
                                    getOptionLabel={(option) => option.client_id}
                                    renderOption={(props, option) => {
                                        const { key, ...optionProps } = props;
                                        return (
                                            <Box key={key} component="li" {...optionProps} >
                                                {option.name} ({option.client_id})
                                            </Box>
                                        );
                                    }}
                                    renderInput={(params) => <TextField {...params} variant="outlined" name="client" fullWidth error={inputErrors.client} type="text" helperText={inputErrors.client} autoFocus placeholder="Client" label="Client" />}
                                />
                            </Zoom> : ""
                        }
                    </Grid>
                    <Grid size={{ xs: 12, sm: 4 }}>
                        <TextField variant="outlined" name="packaging" defaultValue={0} fullWidth error={inputErrors.packaging} type="number" slotProps={{ htmlInput: { step: 0.01, min: 0, max: 100000 } }} helperText={inputErrors.packaging} placeholder=" ₹" label="Packaging Charge" onKeyUp={handlePackagingChange} />
                    </Grid>
                    <Grid size={{ xs: 12, sm: 12 }}>
                        <TextField variant="outlined" name="desc" defaultValue={" "} fullWidth error={inputErrors.description} type="text" helperText={inputErrors.description} placeholder="Description" label="Description" />
                    </Grid>
                    <Grid size={{ xs: 12, sm: 4 }}>
                        <TextField variant="outlined" name="total" defaultValue={0} fullWidth error={inputErrors.total} type="number" slotProps={{ htmlInput: { step: 0.01, min: 0, max: 100000 } }} helperText={inputErrors.total} placeholder=" ₹" label="Total" onBlur={handleTotalChange} />
                    </Grid>
                    <Grid size={{ xs: 12, sm: 4 }}>
                        <Box sx={{ '& > :not(style)': { m: 1 }, textAlign: "center" }}>
                            {isCnWise ?
                                <Zoom in={isCnWise} unmountOnExit>
                                    <Fab variant="circular" size="medium" color="info" onClick={handleTypeSwitch}>
                                        <Inventory2TwoTone />
                                    </Fab>
                                </Zoom> : ""}
                            {!isCnWise ?
                                <Zoom in={!isCnWise} unmountOnExit>
                                    <Fab variant="circular" size="medium" color="info" onClick={handleTypeSwitch}>
                                        <BusinessTwoTone />
                                    </Fab>
                                </Zoom> : ""}
                        </Box>
                    </Grid>
                    <Grid size={{ xs: 12, sm: 12 }}>
                        <Divider />
                    </Grid>
                    <Grid size={{ xs: 12, sm: 6 }}>
                        <FormControlLabel control={<Switch name="is_fuel" />} label="Fuel Surcharge" disabled={taxLock} onChange={handleIsFuelChange} checked={isFuel} />
                    </Grid>
                    <Grid size={{ xs: 12, sm: 6 }}>
                        <FormControlLabel control={<Switch name="is_gst" label="gst" />} disabled={taxLock} label="GST on price" onChange={handleIsGstChange} checked={isGst} />
                    </Grid>
                    <Grid size={{ xs: 6, sm: 3 }}>
                        <TextField variant="outlined" name="fuel_rate" disabled={!isFuel || taxLock} defaultValue={35} fullWidth error={inputErrors.fuel_rate} type="number" slotProps={{ htmlInput: { step: 0.01, min: 0, max: 50 } }} helperText={inputErrors.fuel_rate} placeholder="Percentage" label="Fuel Surchate Rate" onKeyUp={handleFuelrateChange} />
                    </Grid>
                    <Grid size={{ xs: 6, sm: 3 }}>
                        <TextField variant="outlined" name="fuel" disabled={!isFuel} defaultValue={0} fullWidth error={inputErrors.fuel} type="number" slotProps={{ htmlInput: { step: 0.01, min: 0, max: 100000 } }} helperText={inputErrors.fuel} placeholder="Fuel (35%)" label="Fuel" onKeyUp={handleFuelChange} />
                    </Grid>
                    <Grid size={{ xs: 6, sm: 3 }}>
                        <TextField variant="outlined" name="gst_rate" disabled={!isGst || taxLock} defaultValue={18} fullWidth error={inputErrors.gst_rate} type="number" slotProps={{ htmlInput: { step: 0.01, min: 0, max: 38 } }} helperText={inputErrors.gst_rate} placeholder="Percentage" label="GST Rate" onKeyUp={handleGstRateChange} />
                    </Grid>
                    <Grid size={{ xs: 6, sm: 3 }}>
                        <TextField variant="outlined" name="gst" disabled={!isGst} defaultValue={0} fullWidth error={inputErrors.gst} type="number" slotProps={{ htmlInput: { step: 0.01, min: 0, max: 100000 } }} helperText={inputErrors.gst} placeholder=" ₹" label="GST (Amount + Packaging + Pickup + Other)" onKeyUp={handleGSTChange} />
                    </Grid>
                    <Grid size={{ xs: 12, sm: 12 }}>
                        <Button type="submit" variant="contained" fullWidth onClick={validateInputs} color="success">Save</Button>
                    </Grid>
                </Grid>
                {bookingList === null || bookingList.length === 0 ? "" :
                    <TableContainer component={Paper}>
                        <Table size="small" sx={{ minWidth: "100%" }} aria-label="Packaging Details" className="nowrap">
                            <TableHead>
                                <TableRow sx={{ '&:last-child td, &:last-child th': { fontWeight: "bold" } }}>
                                    <TableCell>#ID</TableCell>
                                    <TableCell>Date</TableCell>
                                    <TableCell>Consignment</TableCell>
                                    <TableCell>description</TableCell>
                                    <TableCell align="right">Amount</TableCell>
                                    <TableCell><Chip label="Amount" size="small" color="success" /> <Chip label="Fuel" size="small" color="info" /> <Chip label="GST" size="small" color="warning" /></TableCell>
                                    <TableCell align="right">&nbsp;</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {
                                    bookingList.map((item, idx) => {
                                        return (
                                            <TableRow key={idx}>
                                                <TableCell>PKG{item.pack_id}</TableCell>
                                                <TableCell>{item.created}</TableCell>
                                                <TableCell>{item.cn_ref}</TableCell>
                                                <TableCell>{item.description}</TableCell>
                                                <TableCell align="right">₹ {(item.amount + item.fuel + item.gst).toFixed(2)}</TableCell>
                                                <TableCell><Chip label={"₹" + item.amount.toFixed(2)} size="small" color="success" /> <Chip label={"₹" + item.fuel.toFixed(2)} size="small" color="info" /> <Chip label={"₹" + item.gst.toFixed(2)} size="small" color="warning" /></TableCell>
                                                <TableCell align="right">
                                                    <IconButton aria-label="delete" onClick={(e) => handleDeletePackaging(item)}>
                                                        <DeleteIcon />
                                                    </IconButton>
                                                </TableCell>
                                            </TableRow>
                                        );
                                    })
                                }
                            </TableBody>
                        </Table>
                    </TableContainer>
                }
            </Grid>
        </MenuFrame>
    );
}

export default Packaging;